import React from 'react';

export default function DeluxeEnvFields({
  prefix,
  title,
  help,
  form,
  onChange,
  configured,
}) {
  const id = (name) => `deluxe-${prefix}-${name}`;
  const keep = configured ? 'Leave blank to keep the saved value' : '';

  return (
    <div className="platform-credentials-subsection">
      <h3 className="platform-credentials-subsection__title">{title}</h3>
      {help ? <p className="app-settings-help">{help}</p> : null}
      <div className="pkg-dialog-row">
        <div className="pkg-dialog-field">
          <label htmlFor={id('client-id')}>Client ID</label>
          <input
            id={id('client-id')}
            className="pkg-dialog-input"
            type="text"
            value={form.clientId}
            onChange={onChange('clientId')}
            placeholder={keep || 'Optional for Embedded Payments'}
            autoComplete="off"
          />
        </div>
        <div className="pkg-dialog-field">
          <label htmlFor={id('client-secret')}>Client Secret</label>
          <input
            id={id('client-secret')}
            className="pkg-dialog-input"
            type="password"
            value={form.clientSecret}
            onChange={onChange('clientSecret')}
            placeholder={keep || 'Optional for Embedded Payments'}
            autoComplete="new-password"
          />
        </div>
      </div>
      <div className="pkg-dialog-row">
        <div className="pkg-dialog-field">
          <label htmlFor={id('access-token')}>Access Token</label>
          <input
            id={id('access-token')}
            className="pkg-dialog-input"
            type="password"
            value={form.accessToken}
            onChange={onChange('accessToken')}
            placeholder={keep || 'Access Token (GUID)'}
            autoComplete="new-password"
          />
        </div>
        <div className="pkg-dialog-field">
          <label htmlFor={id('signature-key')}>Signature Key</label>
          <input
            id={id('signature-key')}
            className="pkg-dialog-input"
            type="password"
            value={form.signatureKey}
            onChange={onChange('signatureKey')}
            placeholder={keep || 'Signature Key'}
            autoComplete="new-password"
          />
        </div>
      </div>
    </div>
  );
}
